import { Download, Send, Clock3 } from "lucide-react";
import { blastPending, countdownPending } from "../../lib/leadStats";

const TABS = ["applications", "leads", "perks"];

const BlastButtons = ({ leads, onOpenBlast }) => {
  const pending = blastPending(leads);
  const cdPending = countdownPending(leads);
  return (
    <>
      <button
        type="button"
        onClick={() => onOpenBlast("countdown")}
        disabled={cdPending === 0}
        data-testid="admin-countdown-blast"
        className="inline-flex h-11 items-center gap-2 rounded-full border border-forest/20 bg-white px-5 text-sm font-bold text-forest transition-colors hover:border-fresh hover:text-fresh disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Clock3 className="h-4 w-4" />
        {cdPending === 0 ? "Teaser sent to all" : `Countdown teaser (${cdPending})`}
      </button>
      <button
        type="button"
        onClick={() => onOpenBlast("launch")}
        disabled={pending === 0}
        data-testid="admin-launch-blast"
        className="inline-flex h-11 items-center gap-2 rounded-full bg-fresh px-5 text-sm font-bold text-white transition-colors hover:bg-forest disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Send className="h-4 w-4" />
        {pending === 0 ? "Blast sent to all" : `Send launch blast (${pending})`}
      </button>
    </>
  );
};

export const AdminToolbar = ({ tab, onTab, leads, onOpenBlast, onExport }) => (
  <div className="mt-10 flex items-center justify-between gap-2">
    <div className="flex gap-2">
      {TABS.map((t) => (
        <button
          key={t}
          type="button"
          data-testid={`admin-tab-${t}`}
          onClick={() => onTab(t)}
          className={`h-11 rounded-full px-6 text-sm font-bold capitalize transition-colors ${
            tab === t ? "bg-forest text-bone" : "bg-white text-forest/80 hover:text-forest"
          }`}
        >
          {t}
        </button>
      ))}
    </div>
    <div className="flex flex-wrap items-center gap-2">
      {tab === "leads" && <BlastButtons leads={leads} onOpenBlast={onOpenBlast} />}
      {tab !== "perks" && (
        <button
          type="button"
          onClick={onExport}
          data-testid="admin-export-csv"
          className="inline-flex h-11 items-center gap-2 rounded-full border border-forest/15 bg-white px-5 text-sm font-bold text-forest transition-colors hover:border-fresh hover:text-fresh"
        >
          <Download className="h-4 w-4" /> Export CSV
        </button>
      )}
    </div>
  </div>
);
